import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToHash = () => {
  const { hash, state } = useLocation() as any;

  useEffect(() => {
    if (!hash) return;
    // Wait a tick for the page to render the target element
    const id = hash.startsWith('#') ? hash : `#${hash}`;
    const headerOffset = 96;
    const extraOffsetDown = 60;

    const scrollOnce = () => {
      const el = document.querySelector(id) as HTMLElement | null;
      if (!el) return;
      const rectTop = el.getBoundingClientRect().top + window.pageYOffset;
      const targetY = rectTop - headerOffset + extraOffsetDown;
      const useInstant = state && state.instant;
      window.scrollTo({ top: targetY, behavior: useInstant ? 'auto' : 'smooth' });
    };

    // Initial scroll after a short delay
    const timer = window.setTimeout(scrollOnce, 100);

    // Re-scroll a few times to counter layout shifts from late content/images
    let attempts = 0;
    const interval = window.setInterval(() => {
      attempts += 1;
      scrollOnce();
      if (attempts >= 12) {
        window.clearInterval(interval);
      }
    }, 150);

    return () => {
      window.clearTimeout(timer);
      window.clearInterval(interval);
    };
  }, [hash]);

  return null;
};

export default ScrollToHash;

